import { Page } from '@/core/architecture'

import { StorePurchaseOrdersTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * StorePurchaseOrders Page
 * Implemented as a practical sample.
 */
export const StorePurchaseOrders: Page = () => {
  const { state, actions } = useViewModel()

  return <StorePurchaseOrdersTemplate state={state} {...actions} />
}
